<hx-table
  [maxHeight]="maxHeight()"
  [footerFixed]="footerFixed()"
  [rowHeight]="rowHeight()"
  [headerVariant]="headerVariant()"
  [rowVariant]="rowVariant()"
  [hoverVariant]="hoverVariant()"
  [enableRowHover]="enableRowHover()"
  [disabled]="disabled()"
  [noDataMessage]="noDataMessage()"
  [resizableColumns]="resizableColumns()"
  (columnsResized)="onColumnsResized($event)"
  class="data-table">
  <!-- Table Header -->
  <hx-table-header>
    <!-- Selection / column-config Column Header -->
    @if (showLeadColumn()) {
      <hx-header-cell [width]="leadColumnWidth()" [align]="'center'">
        <div class="hx-data-table__lead-header">
          @if (isMultipleSelection()) {
            <hx-checkbox
              [options]="headerCheckboxOptions()"
              [(selectedValues)]="allRowsSelectedValues"
              (selectedValuesChange)="onSelectAllRows($event)"
              [className]="'hx-data-table-checkbox'" />
          }
          @if (isColumnConfigInLeadCell()) {
            <ng-container *ngTemplateOutlet="columnConfigButton"></ng-container>
          }
        </div>
      </hx-header-cell>
    }

    <!-- Column Headers -->
    @for (column of visibleColumns(); track column.id) {
      <hx-header-cell
        [width]="column.width"
        [class]="column.className"
        [tooltip]="column.label"
        [sortable]="column.sortable || false"
        [sortDirection]="
          currentColumnSorted()?.columnId === column.id ? (currentColumnSorted()?.direction ?? null) : null
        "
        (sort)="onColumnSort(column)">
        @if (enableColumnConfig() && column.id === columnConfigHostId()) {
          <span class="hx-data-table__column-config-host">
            <span>{{ column.label }}</span>
            <ng-container *ngTemplateOutlet="columnConfigButton"></ng-container>
          </span>
        } @else {
          {{ column.label }}
        }
      </hx-header-cell>
    }
  </hx-table-header>

  <!-- Table Rows -->
  @for (row of displayRows(); let index = $index; track index) {
    <hx-table-row (dblclick)="!isRowDisabled(index) && onRowDoubleClick(index)">
      <!-- Selection Column -->
      @if (showLeadColumn()) {
        <hx-table-cell align="center">
          @if (!isRowSelectionHidden(index)) {
            @if (isMultipleSelection()) {
              <hx-checkbox
                [options]="[{ label: '', value: 'select-row' }]"
                [selectedValues]="getRowCheckboxValues(index)"
                (selectedValuesChange)="onRowCheckboxChange(index, $event)"
                [disabled]="isRowDisabled(index)"
                [className]="'hx-data-table-checkbox'" />
            } @else if (isSingleSelection()) {
              <hx-radio
                [name]="'data-table-selection'"
                [value]="index"
                [checkedOverride]="isRowRadioChecked(index)"
                [disabled]="isRowDisabled(index)"
                (change)="onRowRadioChange($event)"></hx-radio>
            }
          }
        </hx-table-cell>
      }

      <!-- Data Cells -->
      @for (column of visibleColumns(); track column.id) {
        <hx-table-cell [class]="column.className">
          @if (column.template) {
            <ng-container
              *ngTemplateOutlet="
                column.template;
                context: { value: getRowValue(row, column.field, column), row: row, rowIndex: index }
              "></ng-container>
          } @else if (column.actions) {
            <hx-action-group
              [actions]="column.actions(row)"
              [row]="row"
              [config]="column.actionGroupConfig"></hx-action-group>
          } @else {
            <span class="hx-data-table-cell__text" hxEllipsisTooltip>
              {{ getRowValue(row, column.field, column) }}
            </span>
          }
        </hx-table-cell>
      }
    </hx-table-row>
  }
  <!-- Pagination Controls using HxPagination Component -->
  @if (enablePagination()) {
    <hx-table-footer>
      <hx-pagination
        [totalRecordCount]="totalRecords()"
        [showTotalRecordCount]="showTotalRecordCount()"
        [(currentPage)]="currentPage"
        [(pageSize)]="pageSize"
        [pageSizeOptions]="pageSizeOptions()"
        [disabled]="disabled()"
        (pageNumberChange)="onPaginationPageChange($event)"
        (pageSizeChangeEvent)="onPaginationPageSizeChange($event)"></hx-pagination>
    </hx-table-footer>
  }
</hx-table>

<ng-template #columnConfigButton>
  <button
    type="button"
    class="hx-data-table__column-config-trigger"
    [class.is-configured]="hasCustomColumnConfig()"
    [hxPopover]="columnConfigPopover"
    trigger="click"
    position="bottom"
    [backdrop]="true"
    title="Configure columns"
    aria-label="Configure columns">
    <hx-icon svgIcon="columns" size="14" />
  </button>
</ng-template>

<ng-template #columnConfigPopover>
  <div class="hx-data-table__column-config">
    <div class="hx-data-table__column-config-header">
      <span class="hx-data-table__column-config-title">{{ columnConfigTitle() }}</span>
      <button type="button" class="hx-data-table__column-config-reset" (click)="resetColumnConfig()">Reset</button>
    </div>
    <div class="hx-data-table__column-config-list">
      @for (option of columnConfigOptions(); track option.id) {
        <label class="hx-data-table__column-config-item" [class.is-locked]="option.locked">
          <input
            type="checkbox"
            [checked]="option.checked"
            [disabled]="option.locked"
            (change)="toggleColumn(option.id)" />
          <span>{{ option.label }}</span>
        </label>
      }
    </div>
  </div>
</ng-template>
